/**
 * Shared Loading Spinner Component
 */

import { Box, CircularProgress, Typography } from '@mui/material';

interface LoadingSpinnerProps {
  message?: string;
  fullHeight?: boolean;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = 'Loading...',
  fullHeight = true,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        height: fullHeight ? '100vh' : '300px',
        gap: 2,
      }}
    >
      <CircularProgress />
      {message && (
        <Typography variant="body2" sx={{ color: '#6b7280' }}>
          {message}
        </Typography>
      )}
    </Box>
  );
};

export default LoadingSpinner;
